import React, { useState, useRef } from "react";
import styles from "./Contact.module.css";
import emailjs from "@emailjs/browser";

function Contact() {
  const [isSent, setIsSent] = useState(false);
  const [isNotSent, setIsNotSent] = useState(false);
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userMessage, setUserMessage] = useState("");
  function handleCloseModal() {
    setIsSent(false);
  }
  function handleCloseModal2() {
    setIsNotSent(false);
  }
  function handleUserName(e) {
    setUserName(e.target.value);
  }
  function handleUserEmail(e) {
    setUserEmail(e.target.value);
  }
  function handleUserMessage(e) {
    setUserMessage(e.target.value);
  }
  const form = useRef();

  const sendEmail = e => {
    e.preventDefault();
    setUserEmail("");
    setUserMessage("");
    setUserName("");
    emailjs
      .sendForm(
        "service_vsdebhy",
        "template_ce4hdof",
        form.current,
        "QoSIj2ylvI5idMiiU"
      )
      .then(
        result => {
          console.log(result.text);
          e.target.reset();
          console.log("Message sent");
          setIsSent(!isSent);
        },
        error => {
          console.log(error.text);
          setIsNotSent(!isNotSent);
        }
      );
  };

  return (
    <section className={styles.section} id="contact">
      <h3>Let's Create Together</h3>
      <p>
        I'm not just here to write lines of code; I'm here to bring ideas to
        life. Whether you're a business looking to enhance your online presence
        or an individual with a visionary app idea, I'm ready to collaborate and
        make it happen. Let's connect, brainstorm, and turn possibilities into
        realities. Fill the form below and I'll be looking forward to creating
        something amazing together!
      </p>
      <div className={styles.container}>
        <div className={styles.formContainer}>
          <form ref={form} onSubmit={sendEmail}>
            <input
              type="text"
              placeholder="What's your name?"
              required
              name="from_name"
              value={userName}
              onChange={handleUserName}
            />
            <input
              type="email"
              value={userEmail}
              onChange={handleUserEmail}
              required
              placeholder="Email"
              name="user_email"
            />
            <textarea
              cols="30"
              rows="10"
              required
              name="message"
              value={userMessage}
              placeholder="Your message"
              onChange={handleUserMessage}
            ></textarea>
            <button className="btn btn-primary">
              {`Send Message `}
              <span>&rarr;</span>
            </button>
          </form>
        </div>
      </div>
      {isSent ? (
        <div className={styles.div}>
          <p>
            Your message was sent successfully! I'll get back to you shortly ✅
            <span onClick={handleCloseModal}>Close</span>
          </p>
        </div>
      ) : (
        ""
      )}

      {isNotSent ? (
        <div className={styles.div}>
          <p>
            Something went wrong! Try again ✅
            <span onClick={handleCloseModal2}>Close</span>
          </p>
        </div>
      ) : (
        ""
      )}
    </section>
  );
}

export default Contact;
